'use strict'

class BlueprintSidebar {

	constructor() {

		var windowResolutions = jQuery(window).width();
		
		function addBlurredEffect() {
	        var urlParams = new URLSearchParams(window.location.search);
	        var noBlurParam = urlParams.get('gated');
	        var form = jQuery('.tps-form-hubspot-full-width');

			if (form.length) {
				if ( noBlurParam === 'true' ) {
					form.removeClass('d-none');
					form.prev().addClass('form-before-section');
					form.nextAll().each(function() {
						jQuery(this).addClass('blurred-section');
					});
					checkForm();
				}
			}

			function checkForm() {
				var formTag = document.querySelector('.tps-form-hubspot-form form');
				var formBeforeSection = document.querySelector('.form-before-section');
				if (formTag) {
				  var formContainer = formTag.closest('.tps-form-hubspot-form');
				  if (formContainer) {
				      var formContainerHeight = formContainer.clientHeight;
				      var bottomValue = formContainerHeight / 1.475;
				      var paddingBottomValue = formContainerHeight / 2.36;
				      formContainer.style.bottom = `-${bottomValue}px`;
				      if (formBeforeSection) {
							formBeforeSection.style.paddingBottom = `${paddingBottomValue}px`;
				      }
				  }
				} else {
				  setTimeout(checkForm, 1000);
				}
			}
		}

		function ChapterNavigation() {
			var currentChapter = jQuery('.sidebar-item-link.active').data('chapter');
			jQuery('.sidebar-item-link').on('click', function(event) {
				event.preventDefault();
				var targetChapter = jQuery(this).data('chapter');

				if (targetChapter == currentChapter) {
					if (currentChapter > 0) {
						jQuery('html, body').animate({
							scrollTop: jQuery('#chapter-' + currentChapter).offset().top
						}, 500);
					}
				} else {
					window.location.href = jQuery(this).attr('href');
				}
			});
		}

		jQuery(document).ready(function() {

			function getCookie(cookieName) {
			    var name = cookieName + "=";
			    var decodedCookie = decodeURIComponent(document.cookie);
			    var cookieArray = decodedCookie.split(';');
			    for (var i = 0; i < cookieArray.length; i++) {
			        var cookie = cookieArray[i].trim();
			        if (cookie.indexOf(name) == 0) {
			            return cookie.substring(name.length, cookie.length);
			        }
			    }
			    return "";
			}

			var blueprintFormSubmittedValue = getCookie('blueprintFormSubmitted');
			var ghostFormSubmittedValue = getCookie('ghostFormSubmitted');
			var bluePrintTemplate = document.querySelector('.single-blueprint-post-content');
			var ghostForm = document.querySelector('.ghost-form');

			if ((bluePrintTemplate && !blueprintFormSubmittedValue) || (ghostForm && !ghostFormSubmittedValue)) {
			    addBlurredEffect();
			}
			if ((bluePrintTemplate && blueprintFormSubmittedValue) || (ghostForm && ghostFormSubmittedValue)) {
			    jQuery('.tps-form-hubspot-full-width.blueprint-form, .tps-form-hubspot-full-width.ghost-form').hide();
			}

			let isSidebarButtonClicked = false;
			var body = jQuery('body');
			if (body.hasClass('single-blueprint')) {
				ChapterNavigation();
				toggleStickyNav(true);
				if (windowResolutions > 1025) {
					jQuery(window).on('scroll', function() {
						if (isSidebarButtonClicked) {
			                return; // Skip scroll handling if the sidebar button was clicked
			            }
						var scrollTop = jQuery(window).scrollTop();
							if (scrollTop === 0) {
								toggleStickyNav(true);
							} else {
								toggleStickyNav();
							}
					});
				}

				function toggleStickyNav(open = false, click = false) {
				    if( click ) {
						jQuery('.single-blueprint-post-container').toggleClass('sticky-nav-open');
						if (windowResolutions < 1025) {
							jQuery('body').toggleClass('overflow-hidden');
						}
				    } else {
				    	if (window.innerWidth > 1024) {
							if (open) {
								jQuery('.single-blueprint-post-container').addClass('sticky-nav-open');
							} else {
								jQuery('.single-blueprint-post-container').removeClass('sticky-nav-open');
							}
						}
				    }

				}

				jQuery(window).resize(function() {
				    if (window.innerWidth <= 1024) {
				        jQuery('.single-blueprint-post-container').removeClass('sticky-nav-open');
				        jQuery('body').removeClass('overflow-hidden');
				    }
				});

				jQuery('.sidebar-button').click(function() {
					isSidebarButtonClicked = true; // Set flag to true when sidebar button is clicked
				    toggleStickyNav(false, true);
				    setTimeout(function() {
		                isSidebarButtonClicked = false;
		            }, 500); // Adjust the timeout duration if necessary
				});
			}

			if (body.hasClass('single-blueprint') || body.find('.ghost-form').length) {
				var $window = jQuery(window);
			    var $form = jQuery('.tps-form-hubspot-form');
			    var formContainerTop = jQuery('.blueprint-form, .ghost-form').offset().top;
			    var stopPoint = jQuery('footer').offset().top + jQuery('footer').height() / 2;

			    $window.scroll(function() {
			        var scrollTop = $window.scrollTop();
			        var windowHeight = $window.height();

			        if (scrollTop > formContainerTop && scrollTop + windowHeight < stopPoint) {
			            $form.addClass('sticky-form').removeClass('sticky-form-stop');
			        } else if (scrollTop <= formContainerTop) {
			            $form.removeClass('sticky-form sticky-form');
			        }
			    });
			}

			if(windowResolutions < 1025) {
				jQuery(document).on('click', '.single-blueprint-post-container a[href^="#"]', function (event) {
					event.preventDefault();
					let target = jQuery(jQuery.attr(this, 'href'));
					if (target.length) {
						jQuery('html, body').animate({
						    scrollTop: target.offset().top - 140 // Adjust scroll position with a 100px offset
						}, 200); // Animate the scroll with a 500ms duration
					}
				});
			}

		    function StickyBarAnimateModal() {
				//Sticky bar download and share button
			    jQuery('.social-share-button').click(function(event) {
			    	event.stopPropagation();
					var $socialShareBtn = jQuery(this);
					var $socialShareModal = $socialShareBtn.parents(".social-share-enabled").find('.stickybar-social-share-wrapper');
			    	if($socialShareModal.hasClass("show")) {
			    		$socialShareModal.removeClass("show");
			    	} else {
			            $socialShareModal.addClass("show");
			    	}
			    });
			    jQuery('.stickybar-social-close').click(function(event) {
			    	event.stopPropagation();
					var $socialShareCloseBtn = jQuery(this);
					var $socialShareModal = $socialShareCloseBtn.closest(".stickybar-social-share-wrapper");
			    	if($socialShareModal.hasClass("show")) {
			    		$socialShareModal.removeClass("show");
			    	}
			    });
			    jQuery(window).click(function(event) {
					jQuery(".stickybar-social-share-wrapper.show").each(function() {
						var $socialShareModal = jQuery(this);
						var $socialShareCloseBtn = $socialShareModal.find('.stickybar-social-close');
						if ($socialShareModal.length && !jQuery(event.target).closest($socialShareModal).length && !jQuery(event.target).is($socialShareCloseBtn)) {
							$socialShareModal.removeClass("show");
						}
					});
			    });
			}
			StickyBarAnimateModal();
		}); //document ready close	
	}
}